import { Box, useTheme } from '@mui/material';
import React from 'react';

import { linkActiveCID } from '../Link';

export interface UnorderedListProps {
  children: React.ReactNode;
}

const UnorderedList = ({ children }: UnorderedListProps): JSX.Element => {
  const theme = useTheme();

  return (
    <Box
      component="ul"
      sx={{
        '.Modal > div > div >.Container > &, .Modal > div > &': {
          color: theme.palette.common.white,
        },
        [`& .${linkActiveCID}`]: {
          fontWeight: 'bold',
        },
      }}
    >
      {children}
    </Box>
  );
};

export default UnorderedList;
